import registryService from "../../services/RegistryService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchBranches = createAsyncThunk(
  "registry/fetchBranches",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await registryService.getAllBranches(data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);
export const fetchTags = createAsyncThunk(
  "registry/fetchTags",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await registryService.getAllTags(data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const registryAnalyze = createAsyncThunk(
  "registry/registryAnalyze",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await registryService.analyze(data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const registryProcess = createAsyncThunk(
  "registry/registryProcess",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await registryService.process(data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const registryProcessFramework = createAsyncThunk(
  "registry/registryProcessFramework",
  async (data, { rejectWithValue }) => {
    try {
      const response = await registryService.process_framework(data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ error: error.message || "Unknown error" });
    }
  }
);


export const fetchReleases = createAsyncThunk(
  "registry/fetchReleases",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await registryService.getRelease(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchReleaseAssets = createAsyncThunk(
  "registry/fetchReleaseAssets",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await registryService.getReleaseAssets(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const registryProcessResource = createAsyncThunk(
  "registry/registryProcessResource",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await registryService.process_resource(data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);
